const handleLogout = () => {
    // Clear user-related data
    localStorage.removeItem("otoken"); // or "user", "play", etc.
    localStorage.clear(); // If you want to clear everything
  
    // Redirect to login
    window.location.href = "/";
  };

  export default handleLogout;